import { Card } from 'common';
import { push } from 'connected-react-router';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FieldLinkBox from '../FieldLinkBox/FieldLinkBox';
import './InvoiceCustomerInformation.scss';
function InvoiceCustomerInformation() {
    const dispatch = useDispatch();
    const onClick = () => dispatch(push('/checkout/customerInvoiceInformation'));
    const customerInvoiceReference = useSelector((state) => state.newCheckout.customerInvoiceReference);
    return (React.createElement(Card, { title: "Fakturainformasjon" },
        React.createElement("div", { className: "invoice-customer-reference__message" },
            "Deres referanse p\u00E5 faktura: ",
            customerInvoiceReference),
        React.createElement(FieldLinkBox, { text: 'Endre fakturainformasjon', isValid: true, onClick: onClick })));
}
export default InvoiceCustomerInformation;
